<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
		<h2>Lista dyżurów</h2>
        </div>
        <div class="widget-content">
    
      <section>
        <div class="toolbar">
          <div class="field">
            <label for="month">Miesiąc</label>
            <select id="month" v-model.number="selectedMonth">
              <option v-for="(month, index) in months" :key="month" :value="index">{{ month }}</option>
            </select>
          </div>
          <div class="field">
            <label for="year">Rok</label>
            <select id="year" v-model.number="selectedYear">
              <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
            </select>
          </div>
          <button class="btn-outline today-button" type="button" @click="goToToday">Dzisiaj</button>
          <div class="month-navigation">
            <button class="btn-outline" type="button" @click="changeMonth(-1)">← Poprzedni</button>
            <button class="btn-primary" type="button" @click="changeMonth(1)">Następny →</button>
          </div>
          <button class="btn-pdf" type="button" @click="openMonthlyPdf">
            Pobierz PDF
          </button>
 		  
        </div>

        <div class="calendar-grid">
          <div v-for="dayName in weekDays" :key="dayName" class="weekday">{{ dayName }}</div>
          <button
            v-for="day in calendarDays"
            :key="day.key"
            type="button"
            class="calendar-day"
            :class="{
              'outside-month': !day.inCurrentMonth,
              'is-weekend': day.isWeekend,
              'is-today': day.isToday,
              'has-records': day.recordsCount > 0
            }"
            :disabled="!day.inCurrentMonth"
            @click="openDay(day)"
          >
            <span class="day-number">{{ day.number }}</span>
            <span v-if="day.recordsCount" class="record-count">
              {{ day.recordsCount }} {{ day.recordsCount === 1 ? 'wpis' : 'wpisy' }}
            </span>
            <span v-if="day.isToday" class="today-label">Dzisiaj</span>
          </button>
        </div>
      </section>

      <section class="duty-card monthly-card mt-3">
        <div class="section-heading">
          <div>
            <h3>Dyżury — {{ months[selectedMonth] }} {{ selectedYear }}</h3>
          </div>
          <span class="total-badge">{{ monthlyRecords.length }} rekordów</span>
        </div>

        <div v-if="monthlyRecords.length" class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Data dyżuru</th>
                <th>Pracownik</th>
                <th>Liczba godzin</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record in monthlyRecords" :key="record.id">
                <td>{{ formatDate(record.date) }}</td>
                <td>{{ employeeName(record.employee_id) }}</td>
                <td>{{ formatHours(record.hours) }}</td>
               <td>
                  <div class="row-actions">
                    <button class="action-button edit" type="button" @click="editRecord(record)">Edytuj</button>
                    <button class="action-button delete" type="button" @click="deleteRecord(record)">Usuń</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="empty-state">Brak rekordów dyżurów w tym miesiącu.</div>
      </section>
    </div>

    <div v-if="dayModalOpen" class="modal-backdrop" @click.self="closeDayModal">
      <section class="duty-modal" role="dialog" aria-modal="true" aria-labelledby="day-modal-title">
        <header class="modal-header">
          <div>
            <div class="eyebrow">DYŻURY</div>
            <h3 id="day-modal-title">{{ formatDate(selectedDate) }}</h3>
          </div>
          <button class="close-button" type="button" aria-label="Zamknij" @click="closeDayModal">×</button>
        </header>

        <div class="modal-content">
          <div class="modal-toolbar">
            <p>Lista dyżurów dla wybranego dnia</p>
            <button v-if="!showForm" class="btn-primary" type="button" @click="startCreate">+ Dodaj</button>
          </div>

          <form v-if="showForm" class="record-form" @submit.prevent="saveRecord">
            <h4>{{ editingId === null ? 'Dodaj dyżur' : 'Edytuj dyżur' }}</h4>

            <div class="form-grid">
              <div class="field">
                <label for="employee">Pracownik</label>
                <select id="employee" v-model.number="form.employee_id" required>
                  <option :value="null" disabled>Wybierz pracownika</option>
                  <option v-for="employee in users" :key="employee.id" :value="Number(employee.id)">
                    {{ employeeNameFromUser(employee) }}
                  </option>
                </select>
              </div>

              <div class="field">
                <label for="hours">Liczba godzin</label>
                <select id="hours" v-model.number="form.hours" required>
                  <option v-for="hours in hourOptions" :key="hours" :value="hours">
                    {{ formatHours(hours) }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="formError" class="form-error">{{ formError }}</div>

            <div class="form-actions">
              <button class="btn-outline" type="button" @click="cancelForm">Anuluj</button>
              <button class="btn-primary" type="submit" :disabled="saving">
                {{ saving ? 'Zapisywanie...' : 'Zapisz' }}
              </button>
            </div>
          </form>

          <div v-if="dayRecords.length" class="table-wrap day-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Imię i nazwisko</th>
                  <th>Liczba godzin</th>
                  <th>Akcje</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in dayRecords" :key="record.id">
                  <td>{{ employeeName(record.employee_id) }}</td>
                  <td>{{ formatHours(record.hours) }}</td>
                  <td>
                    <div class="row-actions">
                      <button class="action-button edit" type="button" @click="editRecord(record)">Edytuj</button>
                      <button class="action-button delete" type="button" @click="deleteRecord(record)">Usuń</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="!showForm" class="empty-state">Brak dyżurów w tym dniu.</div>
        </div>
      </section>
    </div>

    <div v-if="loading" class="loading-indicator">Ładowanie dyżurów...</div>
	</div>
	</div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import axios from "axios";

const {hasPermission} = usePermission();

export default {
  components: { AppLayout, hasPermission },

  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    const today = new Date();
    const currentYear = today.getFullYear();

    return {
	  hasPermission,
      selectedMonth: today.getMonth(),
      selectedYear: currentYear,
      selectedDate: this.localDateString(today),
      months: [
        "Styczeń", "Luty", "Marzec", "Kwiecień",
        "Maj", "Czerwiec", "Lipiec", "Sierpień",
        "Wrzesień", "Październik", "Listopad", "Grudzień",
      ],
      weekDays: ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"],
      years: Array.from({ length: 11 }, (_, i) => currentYear - 5 + i),
      records: [],
      dayModalOpen: false,
      showForm: false,
      editingId: null,
      loading: false,
      saving: false,
      formError: "",
      pageError: "",
      requestId: 0,
      form: this.emptyForm(),
    };
  },

  computed: {
    hourOptions() {
      return Array.from({ length: 24 }, (_, i) => (i + 1) * 0.5);
    },

    calendarDays() {
      const firstDay = new Date(this.selectedYear, this.selectedMonth, 1);
      const lastDay = new Date(this.selectedYear, this.selectedMonth + 1, 0);
      const offset = (firstDay.getDay() + 6) % 7;
      const start = new Date(this.selectedYear, this.selectedMonth, 1 - offset);
      const totalDays = Math.ceil((offset + lastDay.getDate()) / 7) * 7;
      const todayKey = this.localDateString(new Date());

      return Array.from({ length: totalDays }, (_, index) => {
        const date = new Date(start);
        date.setDate(start.getDate() + index);
        const key = this.localDateString(date);

        return {
          key,
          number: date.getDate(),
          inCurrentMonth: date.getMonth() === this.selectedMonth,
          isWeekend: date.getDay() === 0 || date.getDay() === 6,
          isToday: key === todayKey,
          recordsCount: this.records.filter(record => record.date === key).length,
        };
      });
    },

    monthlyRecords() {
      const prefix = `${this.selectedYear}-${String(this.selectedMonth + 1).padStart(2, "0")}-`;
      return this.records
        .filter(record => String(record.date || "").startsWith(prefix))
        .slice()
        .sort((a, b) => a.date.localeCompare(b.date));
    },

    dayRecords() {
      return this.records.filter(record => record.date === this.selectedDate);
    },
  },

  watch: {
    selectedMonth() {
      this.fetchRecords();
    },
    selectedYear() {
      if (!this.years.includes(this.selectedYear)) {
        this.years = [...this.years, this.selectedYear].sort((a, b) => a - b);
      }
      this.fetchRecords();
    },
  },

  mounted() {
    this.fetchRecords();
  },

  methods: {
    emptyForm() {
      return {
        employee_id: null,
        hours: 1,
      };
    },

    localDateString(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    openMonthlyPdf() {
      const url = route("dyzury.pdf", {
        year: this.selectedYear,
        month: this.selectedMonth + 1,
      });
      window.open(url, "_blank", "noopener");
    },

    changeMonth(direction) {
      const date = new Date(this.selectedYear, this.selectedMonth + direction, 1);
      this.selectedMonth = date.getMonth();
      this.selectedYear = date.getFullYear();
    },

    goToToday() {
      const today = new Date();
      this.selectedMonth = today.getMonth();
      this.selectedYear = today.getFullYear();
    },

    async fetchRecords() {
      const id = ++this.requestId;
      this.loading = true;
      this.pageError = "";

      try {
        const response = await axios.get(route("dyzury.records.index"), {
          params: { year: this.selectedYear, month: this.selectedMonth + 1 },
        });

        if (id !== this.requestId) return;
        this.records = Array.isArray(response.data.records) ? response.data.records : [];
      } catch (error) {
        if (id !== this.requestId) return;
        this.pageError = "Nie udało się pobrać listy dyżurów.";
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    },

    openDay(day) {
      if (!day.inCurrentMonth) return;
      this.selectedDate = day.key;
      this.dayModalOpen = true;
      this.cancelForm();
    },

    closeDayModal() {
      this.dayModalOpen = false;
      this.cancelForm();
    },

    startCreate() {
      this.editingId = null;
      this.form = {
        ...this.emptyForm(),
      };
      this.formError = "";
      this.showForm = true;
    },

    editRecord(record) {
      this.editingId = record.id;
      this.selectedDate = record.date;
      this.form = {
        employee_id: Number(record.employee_id),
        hours: Number(record.hours),
      };
      this.formError = "";
      this.showForm = true;
      this.dayModalOpen = true;
    },

    cancelForm() {
      this.showForm = false;
      this.editingId = null;
      this.form = this.emptyForm();
      this.formError = "";
    },

    async saveRecord() {
      this.formError = "";

      if (!this.form.employee_id) {
        this.formError = "Wybierz pracownika.";
        return;
      }

      if (!this.form.hours || this.form.hours < 0.5 || this.form.hours > 12) {
        this.formError = "Liczba godzin musi wynosić od 0,5 do 12.";
        return;
      }
      const payload = {
        ...this.form,
        date: this.selectedDate,
      };

      this.saving = true;

      try {
        if (this.editingId === null) {
          await axios.post(route("dyzury.records.store"), payload);
        } else {
          await axios.put(route("dyzury.records.update", this.editingId), payload);
        }

        this.cancelForm();
        await this.fetchRecords();
      } catch (error) {
        this.formError =
          error.response?.data?.message ||
          "Nie udało się zapisać rekordu.";
      } finally {
        this.saving = false;
      }
    },

    async deleteRecord(record) {
      if (!window.confirm(`Czy na pewno usunąć dyżur pracownika ${this.employeeName(record.employee_id)}?`)) {
        return;
      }

      try {
        await axios.delete(route("dyzury.records.destroy", record.id));
        if (this.editingId === record.id) this.cancelForm();
        await this.fetchRecords();
      } catch (error) {
        this.pageError =
          error.response?.data?.message ||
          "Nie udało się usunąć rekordu.";
      }
    },

    employeeName(employeeId) {
      const employee = this.users.find(user => Number(user.id) === Number(employeeId));
      return employee ? this.employeeNameFromUser(employee) : "Nieznany pracownik";
    },

    employeeNameFromUser(employee) {
      if (employee.name) return employee.name;
      return [employee.first_name, employee.last_name].filter(Boolean).join(" ");
    },

    formatHours(hours) {
      const value = Number(hours);
      if (!Number.isFinite(value)) return "—";
      return `${Number.isInteger(value) ? value : value.toFixed(1).replace(".", ",")} godz.`;
    },

    formatDate(value) {
      if (!value) return "—";
      const parts = String(value).slice(0, 10).split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    },
  },
};
</script>

<style scoped>
.duty-page {
  display: grid;
  gap: 24px;
  padding: 24px 0;
  color: #243247;
}
.duty-card {
  padding: 28px;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 18px;
  box-shadow: 0 8px 30px rgba(31, 45, 61, .06);
}
.duty-header, .section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.duty-header {
  padding-bottom: 24px;
  border-bottom: 1px solid #edf0f5;
}
.eyebrow {
  margin-bottom: 8px;
  color: #6480a3;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.7px;
}
.duty-header h2, .section-heading h3, .modal-header h3 {
  margin: 0;
  color: #1d2a3b;
  font-weight: 750;
}
.duty-header h2 { font-size: 27px; }
.section-heading h3, .modal-header h3 { font-size: 21px; }
.navigation, .row-actions, .form-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.btn-outline, .btn-primary, .today-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 15px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  color: #40536c;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}
.btn-outline:hover, .today-button:hover { background: #f4f7fb; }
.btn-primary {
  border-color: #2864d7;
  background: #2864d7;
  color: #fff;
}
.btn-primary:hover { background: #1e52b9; }
.btn-primary:disabled { opacity: .65; cursor: wait; }
.toolbar {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 14px;
  padding: 24px 0;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}
.field label {
  color: #718096;
  font-size: 12px;
  font-weight: 700;
}
.field select, .field input {
  width: 100%;
  min-width: 0;
  height: 43px;
  padding: 0 12px;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  background: #fff;
  color: #25364b;
  font-size: 14px;
}
.toolbar .field:first-child { width: 210px; }
.toolbar .field:nth-child(2) { width: 125px; }
.today-button { height: 43px; }
.month-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-pdf {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 43px;
  padding: 10px 16px;
  border: 1px solid #198754;
  border-radius: 9px;
  background: #198754;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.btn-pdf:hover { background: #146c43; }
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  overflow: hidden;
  border-top: 1px solid #e8edf3;
  border-left: 1px solid #e8edf3;
  border-radius: 10px;
}
.weekday {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 43px;
  padding: 8px 3px;
  border-right: 1px solid #e8edf3;
  border-bottom: 1px solid #e8edf3;
  background: #f6f8fb;
  color: #6c7c91;
  font-size: 12px;
  font-weight: 750;
  text-align: center;
}
.calendar-day {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  min-height: 96px;
  padding: 10px;
  border: 0;
  border-right: 1px solid #e8edf3;
  border-bottom: 1px solid #e8edf3;
  background: #fff;
  text-align: left;
  cursor: pointer;
}
.calendar-day:hover:not(:disabled) { background: #eef5ff; }
.calendar-day:disabled { cursor: default; }
.calendar-day.is-weekend { background: #f8fafc; }
.calendar-day.outside-month { background: #fafbfd; }
.calendar-day.outside-month .day-number { color: #c5ccd6; }
.calendar-day.is-today { box-shadow: inset 0 0 0 2px #3478ed; }
.calendar-day.has-records { background: #eef8f2; }
.day-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  border-radius: 8px;
  color: #33445a;
  font-size: 13px;
  font-weight: 700;
}
.is-today .day-number { background: #2864d7; color: #fff; }
.record-count {
  padding: 4px 6px;
  border-radius: 5px;
  background: #d7f0df;
  color: #21683a;
  font-size: 10px;
  font-weight: 750;
}
.today-label { color: #2864d7; font-size: 10px; font-weight: 750; }
.monthly-card { min-width: 0; }
.total-badge {
  padding: 7px 11px;
  border-radius: 20px;
  background: #edf4ff;
  color: #2864d7;
  font-size: 12px;
  font-weight: 750;
}
.table-wrap { width: 100%; overflow-x: auto; margin-top: 20px; }
table { width: 100%; border-collapse: collapse; text-align: left; }
th, td {
  padding: 13px 12px;
  border-bottom: 1px solid #edf0f5;
  white-space: nowrap;
  font-size: 13px;
}
th { background: #f7f9fc; color: #64748b; font-size: 11px; text-transform: uppercase; letter-spacing: .4px; }
td { color: #33445a; }
tbody tr:hover { background: #fafcff; }
.action-button {
  padding: 7px 10px;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  background: #fff;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.action-button.edit { color: #2864d7; }
.action-button.delete { color: #c53b43; }
.action-button:hover { background: #f4f7fb; }
.empty-state {
  margin-top: 20px;
  padding: 28px 16px;
  border: 1px dashed #dfe6ef;
  border-radius: 10px;
  color: #8793a5;
  text-align: center;
  font-size: 13px;
}
.modal-backdrop {
  position: fixed;
  z-index: 1050;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
  background: rgba(20, 32, 48, .55);
}
.duty-modal {
  width: min(100%, 950px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, .2);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 26px;
  border-bottom: 1px solid #edf0f5;
}
.close-button {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 9px;
  background: #f2f5f9;
  color: #526176;
  font-size: 25px;
  cursor: pointer;
}
.modal-content { padding: 22px 26px 26px; }
.modal-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.modal-toolbar p { margin: 0; color: #718096; font-size: 13px; }
.record-form {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e4ebf4;
  border-radius: 12px;
  background: #f9fbfe;
}
.record-form h4 { margin: 0 0 18px; color: #263950; font-size: 16px; }
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.form-actions { justify-content: flex-end; margin-top: 20px; }
.form-error, .page-error {
  margin-top: 14px;
  padding: 11px 13px;
  border-radius: 8px;
  background: #fff0f0;
  color: #a33434;
  font-size: 13px;
}
.loading-indicator {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1040;
  padding: 11px 15px;
  border-radius: 9px;
  background: #243247;
  color: #fff;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .15);
  font-size: 13px;
}
@media (max-width: 768px) {
  .duty-page { padding: 12px 0; gap: 16px; }
  .duty-card { padding: 16px 12px; border-radius: 12px; }
  .duty-header { align-items: flex-start; flex-direction: column; }
  .duty-header h2 { font-size: 23px; }
  .navigation { width: 100%; }
  .navigation button { flex: 1; padding: 10px 8px; }
  .toolbar .field:first-child { flex: 1; width: auto; }
  .toolbar .field:nth-child(2) { width: 100px; }
  .month-navigation { flex-wrap: wrap; }
  .btn-pdf { margin-left: 0; }
  .weekday { min-height: 38px; font-size: 9px; }
  .calendar-day { min-height: 66px; padding: 4px; gap: 3px; }
  .day-number { width: 25px; height: 25px; font-size: 11px; }
  .record-count { padding: 3px; font-size: 8px; }
  .today-label { font-size: 8px; }
  .modal-backdrop { padding: 10px; }
  .modal-header, .modal-content { padding: 17px 14px; }
  .form-grid { grid-template-columns: 1fr; }
  .row-actions { gap: 5px; }
  .action-button { padding: 7px; }
  th, td { padding: 10px 8px; }
}
</style>